import React from 'react';
import { Col } from 'antd';

import { ApplicationWithDetails } from '../../types';
import { ApplicationCategories } from '../ApplicationCategories/ApplicationCategories';
import { ApplicationConceptions } from '../ApplicationConceptions/ApplicationConceptions';
import { ApplicationCountries } from '../ApplicationCountries/ApplicationCountries';
import { ApplicationDeveloper } from '../ApplicationDeveloper/ApplicationDeveloper';
import { ApplicationLinks } from '../ApplicationLinks/ApplicationLinks';
import { ApplicationVersion } from '../ApplicationVersion/ApplicationVersion';
import { DetailsContainerStyled } from './ApplicationDetails.styles';

interface ApplicationDetailsProps {
	application: ApplicationWithDetails;
}

export const ApplicationDetails: React.FC<ApplicationDetailsProps> = ({ application }) => {
	const { categories, developer, conceptions, webSiteUrl, countries, versionHistory } = application;

	return (
		<DetailsContainerStyled>
			<Col xs={24}>
				<ApplicationCategories categories={categories} />
			</Col>
			<Col xs={24}>
				<ApplicationConceptions conceptions={conceptions} />
			</Col>
			<Col xs={24}>
				<ApplicationCountries countries={countries} />
			</Col>
			<Col xs={24}>
				<ApplicationDeveloper developer={developer} websiteUrl={webSiteUrl} />
			</Col>
			<Col xs={24}>
				<ApplicationLinks application={application} />
			</Col>
			<Col xs={24}>
				<ApplicationVersion versionHistory={versionHistory} version='' />
			</Col>
		</DetailsContainerStyled>
	);
};
